import { render, staticRenderFns } from "./reservas.vue?vue&type=template&id=09d71f2c&"
import script from "./reservas.vue?vue&type=script&lang=js&"
export * from "./reservas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports